import Vue from 'vue';
export default Vue.extend({
    props: {
        applyConfirmInfo: {
            type: Object,
            required: true,
        },
    },
    data: function () {
        return {
            applyConfirm: [
                [
                    {
                        span: 12,
                        label: '开票渠道',
                        value: '',
                    },
                    {
                        span: 12,
                        label: '账单截止日期',
                        value: '',
                    },
                ],
                [
                    {
                        span: 8,
                        label: '本期条目',
                        value: '',
                    },
                    {
                        span: 8,
                        label: '总保费',
                        value: '',
                    },
                    {
                        span: 8,
                        label: '推广费',
                        value: '',
                    },
                ],
            ],
        };
    },
    methods: {
        closeSelf: function () {
            this.$emit('shut');
        },
        showLoading: function () {
            window.loading = Vue.prototype.$loading({
                spinner: 'el-icon-loading',
                background: 'rgba(300, 300, 300, 0.5)',
                customClass: 'loading',
                body: true,
            });
        },
        hideLoading: function () {
            window.loading && window.loading.close();
        },
        commitApply: function () {
            var _this = this;
            this.showLoading();
            this.geneSettleOrder().then(function (res) {
                _this.hideLoading();
                _this.closeSelf();
                if (res) {
                    _this.$message({
                        message: '对账单已生成',
                        type: 'success',
                    });
                    _this.openCheckOrderDetail(res.data.id);
                }
                else {
                    _this.$message({
                        message: '对账单失败',
                        type: 'error',
                    });
                }
            });
        },
        geneSettleOrder: function () {
            var _a = this.applyConfirmInfo, endTime = _a.endTime, partnerIds = _a.partnerIds;
            var _b = this.applyConfirmInfo, sumBillNumber = _b.sumBillNumber, sumAmount = _b.sumAmount, sumOrderAmount = _b.sumOrderAmount;
            var params = {
                endTime: endTime,
                partnerIds: partnerIds,
                sumBillNumber: sumBillNumber,
                sumAmount: sumAmount,
                sumOrderAmount: sumOrderAmount,
            };
            return this.$request({
                url: '/proxy/carInsurance/channelBill/createStatement',
                method: 'post',
                data: params,
            }).then(function (res) {
                if (!res) {
                    return;
                }
                if (res.errorCode) {
                    return;
                }
                return res;
            });
        },
        initShowContent: function () {
            this.applyConfirm[0][0].value = this.applyConfirmInfo.channelName;
            this.applyConfirm[0][1].value = this.applyConfirmInfo.endTime;
            this.applyConfirm[1][0].value = this.applyConfirmInfo.sumBillNumber;
            this.applyConfirm[1][1].value =
                '￥' + this.applyConfirmInfo.sumOrderAmount;
            this.applyConfirm[1][2].value = '￥' + this.applyConfirmInfo.sumAmount;
        },
        openCheckOrderDetail: function (orderId) {
            this.$router.push({
                name: 'insBalanceCheckDetail',
                params: { checkOrderId: orderId.toString() },
            });
        },
    },
    created: function () {
        this.initShowContent();
    },
});
